var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999756 10.334C0.999756 10.954 0.999756 11.264 1.06791 11.5183C1.25284 12.2085 1.79194 12.7476 2.48212 12.9325C2.73646 13.0007 3.04644 13.0007 3.66642 13.0007H10.3331C10.9531 13.0007 11.2631 13.0007 11.5174 12.9325C12.2076 12.7476 12.7467 12.2085 12.9316 11.5183C12.9998 11.264 12.9998 10.954 12.9998 10.334",
    stroke: "#471070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66669C10 6.66669 7.79056 9.66669 6.99996 9.66669C6.20943 9.66669 4 6.66669 4 6.66669M6.99996 9.00003V1",
    stroke: "#471070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.52ae97cc84eb327df82e68c55bfa7227.svg";
export { ForwardRef as ReactComponent };